import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';

/**
 * Contains the following {FormControl}s:
 * * Year
 * * Mileage
 * * Make
 * * Model
 * * Lienholder *
 * * Payments *
 * * Balance Owed *
 *
 * (*) Denotes a control that can be disabled.
 *
 * The parent {FormGroup} can disable unneeded controls. Disabling will hide the controls from the UI.
 *
 * ```typescript
 * this.formBuilder.group({
 *    Lienholder: [{ value: '', disabled: true }]
 * });
 * ```
 */
@Component({
  selector: 'app-vehicle-detail-info',
  templateUrl: './vehicle-detail-info.component.html',
  styleUrls: ['./vehicle-detail-info.component.scss'],
})
export class VehicleDetailInfoComponent implements OnInit {
  @Input() index: number = 0;
  @Input() controls: AbstractControl | null = null;

  /**
   * Gets the current year plus one.
   */
  get year(): number {
    const current = new Date();
    return current.getFullYear() + 1;
  }

  constructor() {}

  ngOnInit(): void {}

  getFormControl(key: string): FormControl {
    if (this.controls?.get(key)) {
      return this.controls.get(key) as FormControl;
    }

    return new FormControl();
  }

  controlIsRequired(key: string): boolean {
    const control = this.getFormControl(key);

    if (control && control.hasValidator(Validators.required)) {
      return true;
    }

    return false;
  }

  controlIsDisabled(key: string): boolean {
    const control = this.getFormControl(key);

    if (control) {
      return control.disabled;
    }

    return false;
  }
}
